import React, { useState, useEffect } from 'react';
import api from '@/lib/api';

export default function AdminAuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entityTypeFilter, setEntityTypeFilter] = useState('');

  useEffect(() => {
    loadLogs();
  }, [entityTypeFilter]);

  const loadLogs = async () => {
    setLoading(true);
    try {
      const params = { limit: 100 };
      if (entityTypeFilter) params.entity_type = entityTypeFilter;
      const { data } = await api.get('/admin/audit-logs', { params });
      setLogs(data.logs);
    } catch (err) {
      console.error('Failed to load audit logs:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-audit-logs">
      <h1 className="font-heading text-3xl font-bold tracking-tight mb-2">Audit Logs</h1>
      <p className="text-sm text-gray-500 mb-6">Track all system actions</p>

      <div className="flex gap-3 mb-6">
        <select
          data-testid="audit-entity-filter"
          value={entityTypeFilter}
          onChange={(e) => setEntityTypeFilter(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-sm text-sm"
        >
          <option value="">All Entities</option>
          <option value="case">Cases</option>
          <option value="user">Users</option>
          <option value="template">Templates</option>
          <option value="template_candidate">Candidates</option>
        </select>
      </div>

      <div className="border border-gray-200">
        <table className="w-full" data-testid="audit-table">
          <thead>
            <tr className="border-b border-gray-200 bg-surface">
              <th className="text-left px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-gray-500">Time</th>
              <th className="text-left px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-gray-500">Entity</th>
              <th className="text-left px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-gray-500">Action</th>
              <th className="text-left px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-gray-500">Actor</th>
              <th className="text-left px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-gray-500">Changes</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400 text-sm">Loading...</td></tr>
            ) : logs.length === 0 ? (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400 text-sm">No audit logs found</td></tr>
            ) : logs.map((log) => (
              <tr key={log.id} className="border-b border-gray-100">
                <td className="px-4 py-3 text-xs font-mono text-gray-500">
                  {log.created_at ? new Date(log.created_at).toLocaleString() : '—'}
                </td>
                <td className="px-4 py-3 text-sm">
                  <span className="font-mono text-xs uppercase bg-surface px-1.5 py-0.5 rounded">{log.entity_type}</span>
                </td>
                <td className="px-4 py-3 text-sm font-medium">{log.action}</td>
                <td className="px-4 py-3 text-sm text-gray-500">{log.actor_role || '—'}</td>
                <td className="px-4 py-3 text-xs font-mono text-gray-400 max-w-xs truncate">
                  {JSON.stringify(log.changes).substring(0, 80)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
